import {
  Button,
  Flex,
  HStack,
  Input,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  Box,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import { importFile } from "../../utils/tools";
import { checkinCall } from "../../api/checkin";
import iconExcel from "../../assets/images/timeKeeping/excel.svg";
import iconFile from "../../assets/images/timeKeeping/file.svg";
import iconClose from "../../assets/images/icon-login.png";
import { bookingCall } from "../../api/booking";
import { lockingCall } from "../../api/locking";
import { apartmentCall } from "../../api/apartment";
import { apartmentBookingEventLinkCall } from "../../api/apartmentBookingEventLink";
import { apartmentSaleOpeningEventLinkCall } from "../../api/apartmentSaleOpeningEventLink";
import { checkinPlaceCall } from "../../api/checkinPlace";
import { employeeCall } from "../../api/employee";
import SearchableSelect from "../selectForm";
import { ttkqCall } from "../../api/ttkq";
import { contractCall } from "../../api/contract";
import { DownloadIcon } from "@chakra-ui/icons";
import { commissionAnalystCall } from "../../api/commissionAnalyst";
import { totalCommissionCall } from "../../api/totalCommission";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import { saleOpeningEventMechanismParametersCall } from "../../api/saleOpeningEventMechanismParameters";
import { brokerDebtCertificateCall } from "../../api/brokerDebtCertificate";
import { brokerDebtDisbursementCall } from "../../api/brokerDebtDisbursement";
import { deviceManagerCall } from "../../api/deviceManager";
import { attendanceCall } from "../../api/attendance";
import { customerCall } from "../../api/customer";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const PopupImport = ({
  isOpen,
  onClose,
  refetchCheckInData,
  columnMappingReverse,
  handleExport,
  titleAdd,
  inputAdd,
  type,
  id,
  isTypePrice,
  isExport,
  exportTitle,
  titleImport,
  onImport,
  isImport,
  isKRate,
  requiredCheck = false,
  titleCheck = "Kiểm tra dữ liệu",
  checkOnly = false,
  importMode = 2,
}) => {
  const [isChecking, setIsChecking] = useState(false);
  const checkingRef = useRef(false);
  const [checkState, setCheckState] = useState({
    hasChecked: false,
    passed: false,
    hasErrorFile: false,
    path: null,
    filename: null,
  });

  const [fileName, setFileName] = useState("");
  const inputFileRef = useRef(null);
  const [typeValue, setTypeValue] = useState(0);
  // Mode import thanh toán CCMG: 2 = tính lại số dư; 1 = chỉ thêm lịch sử
  const [disbursementMode, setDisbursementMode] = useState(importMode || 2);
  const [pathFileError, setPathFileError] = useState(null);
  const [namePathFileError, setNamePathFileError] = useState(null);

  const [saleOpenEvent, setSaleOpenEvent] = useState([]);
  const [saleOpeningEventId, setSaleOpeningEventId] = useState();

  const [dataKRate, setDataKRate] = useState([]);
  const [dataKRateId, setDataKRateId] = useState();

  const {
    isOpen: isOpenError,
    onOpen: onOpenError,
    onClose: onCloseError,
  } = useDisclosure();

  const typeValues = [
    { key: 1, value: "Dấu phẩy" },
    { key: 2, value: "Dấu chấm" },
  ];

  const fectchDataSaleOpeningEventMechanismParameters = async (
    idSaleOpenEvent,
  ) => {
    try {
      const data =
        await saleOpeningEventMechanismParametersCall.listBySaleOpeningEvent(
          idSaleOpenEvent,
        );

      if (data) {
        const dataFilter = data?.map((item) => ({
          key: item?._id,
          value: item?.note
            ? `${item?.kRate} (${item?.note})`
            : item?.kRate,
        }));
        setDataKRate(dataFilter);
      }
    } catch (error) {
      console.log("Lỗi khi fectch dữ liệu quản lý hệ số k");
    }
  };

  const fectchDataSaleOpeningEvent = async () => {
    try {
      const data = await saleOpeningEventCall.list();

      if (data) {
        const dataFilter = data?.map((item) => ({
          key: item?._id,
          value: item?.name,
        }));

        setSaleOpenEvent(dataFilter);
      }
    } catch (error) {
      console.log("Lỗi khi fectch dữ liệu quản lý hệ số k");
    }
  };

  useEffect(() => {
    setTypeValue(0);

    if (isKRate) {
      fectchDataSaleOpeningEvent();
    }
  }, [isOpen]);

  useEffect(() => {
    if (saleOpeningEventId) {
      fectchDataSaleOpeningEventMechanismParameters(saleOpeningEventId);
    }
  }, [saleOpeningEventId]);

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // reset trạng thái check mỗi lần đổi file
      setCheckState({
        hasChecked: false,
        passed: false,
        hasErrorFile: false,
        path: null,
        filename: null,
      });
      setPathFileError(null);
      setNamePathFileError(null);

      if (fileExtension === "xlsx" || fileExtension === "csv") {
        setFileName(file.name);
      } else {
        alert("Vui lòng chọn file có định dạng .xlsx hoặc .csv");
        event.target.value = null;
        setFileName("");
      }
    }
  };

  useEffect(() => {
    if (!requiredCheck) return;

    setCheckState({
      hasChecked: false,
      passed: false,
      hasErrorFile: false,
      path: null,
      filename: null,
    });
    setPathFileError(null);
    setNamePathFileError(null);
  }, [saleOpeningEventId, dataKRateId]);

  const handleCloseError = () => {
    onCloseError();
    if (!requiredCheck) onClose();
  };

  const handleImport = async () => {
    if (requiredCheck && !checkState.passed) {
      toast.error("Vui lòng kiểm tra dữ liệu trước khi import.");
      return;
    }

    if (!inputFileRef.current || !inputFileRef.current.files[0]) {
      toast.error("Vui lòng chọn file để import.");
      return;
    }

    const fileEvent = { target: { files: inputFileRef.current.files } };
    const mapping = columnMappingReverse;

    const run = async () => {
      // 1) parse file (importFile)
      return new Promise((resolve, reject) => {
        importFile(
          fileEvent,
          mapping,
          typeValue,
          async (importedData) => {
            try {
              let data;

              if (type === "bookingImport") {
                data = await bookingCall.bulkImport(importedData);
              } else if (type === "locking") {
                data = await lockingCall.bulkAdd(importedData);
              } else if (type === "contractAgent") {
                data = await contractCall.bulkImport(importedData);
              } else if (type === "ttkqAgent") {
                data = await ttkqCall.bulkImport(importedData);
              } else if (type === "lockingAgent") {
                data = await lockingCall.bulkImport(importedData);
              } else if (type === "apartment") {
                data = await apartmentCall.bulkAdd(importedData);
              } else if (type === "apartmentPrice") {
                data = await apartmentCall.bulkAddPrice(importedData);
              } else if (type === "apartmentRate") {
                data = await apartmentCall.bulkAddRate(importedData);
              } else if (type === "apartmentBookingEventLink") {
                data = await apartmentBookingEventLinkCall.bulkAdd(
                  id,
                  importedData,
                );
              } else if (type === "apartmentSaleOpeningEventLink") {
                data = await apartmentSaleOpeningEventLinkCall.bulkAdd(
                  id,
                  importedData,
                );
              } else if (type === "checkinPlaceParticipant") {
                data = await checkinPlaceCall.bulkImport(id, importedData);
              } else if (type === "employee") {
                data = await employeeCall.bulkAdd(importedData, 1);
              } else if (type === "employeeSupport") {
                data = await employeeCall.bulkAdd(importedData, 0);
              } else if (type === "commissionAnalyst") {
                data = await commissionAnalystCall.bulkAdd(
                  importedData,
                  saleOpeningEventId,
                  dataKRateId,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "bulkCalculator") {
                data = await commissionAnalystCall.bulkCalculator(
                  importedData,
                  saleOpeningEventId,
                  dataKRateId,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "bulkImportDevice") {
                data = await deviceManagerCall.import(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importAttendanceSupportBusiness") {
                data = await attendanceCall.importAttendanceSupportBusiness(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importAttendanceBusiness") {
                data = await attendanceCall.importAttendanceBusiness(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importTotalCommission") {
                data = await totalCommissionCall.importTotalCommission(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "deleteTotalCommission") {
                // Xoá đợt thanh toán đã import — khớp theo Mã căn + Ngày thanh toán.
                data = await totalCommissionCall.deletePaymentPeriodByImport(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importBrokerDebtDisbursement") {
                data = await brokerDebtCertificateCall.import(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCcmgByPeriod") {
                // Import CCMG thủ công theo đợt × căn × nhân viên.
                // Chỉ cho phép nếu chưa có PDV (IndividualServiceFee) cho bộ khóa đó.
                data = await brokerDebtCertificateCall.importByPeriod(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCcmgDisbursement") {
                // Import thanh toán CCMG — ghi đè theo (nhân viên × ngày thanh toán).
                // mode 1: chỉ thêm lịch sử. mode 2: thêm lịch sử + tính lại số dư.
                data = await brokerDebtDisbursementCall.import(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                  disbursementMode,
                );
              } else if (type === "employeeImport") {
                data = await employeeCall.bulkMany(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "leaveBalanceImport") {
                data = await employeeCall.importLeaveBalance(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "customerImport") {
                data = await customerCall.import(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCalculatorApartment") {
                data = await saleOpeningEventCall.importCalculator(
                  id,
                  importedData,
                );
              } else {
                data = await checkinCall.bulkAdd(importedData);
              }

              // 2) refetch + handle file error
              if (
                data &&
                (type === "importBrokerDebtDisbursement" ||
                  type === "importCcmgByPeriod" ||
                  type === "importCcmgDisbursement" ||
                  type === "bulkCalculator" ||
                  type === "commissionAnalyst" ||
                  type === "importTotalCommission" ||
                  type === "deleteTotalCommission" ||
                  type === "customerImport")
              ) {
                if (refetchCheckInData) await refetchCheckInData();
                // toast.success(
                //   `Dữ liệu ${data?.successCount || 0}/${
                //     (data?.successCount || 0) + (data?.failedCount || 0)
                //   }`
                // );

                if (data?.path && data?.filename) {
                  setPathFileError(data.path);
                  setNamePathFileError(data.filename);
                  onOpenError();
                  return resolve({ data, hasErrorFile: true });
                }

                return resolve({ data, hasErrorFile: false });
              }

              if (refetchCheckInData) await refetchCheckInData();
              return resolve({ data, hasErrorFile: false });
            } catch (err) {
              return reject(err);
            }
          },
          // false,
        );
      });
    };

    try {
      const result = await toast.promise(
        run(),
        {
          loading: "Đang import dữ liệu...",
          success: (res) => {
            // nếu có file lỗi thì message khác chút
            if (res?.hasErrorFile) {
              return `Import xong (có file lỗi) ${res?.data?.successCount || 0
                }/${(res?.data?.successCount || 0) + (res?.data?.failedCount || 0)
                }`;
            }

            // nếu có successCount/failedCount thì show chi tiết
            if (res?.data?.successCount !== undefined) {
              return `Tải dữ liệu thành công ${res?.data?.successCount || 0}/${(res?.data?.successCount || 0) + (res?.data?.failedCount || 0)
                }`;
            }

            return "Tải dữ liệu thành công";
          },
          error: "Import thất bại, vui lòng kiểm tra lại file.",
        },
        {
          // tránh toast bị dismiss sớm do click nhiều lần
          // duration: 4000,
        },
      );

      // nếu không có file lỗi thì đóng modal import
      // if (!result?.hasErrorFile) onClose();
    } catch (error) {
      console.error("Import error:", error);
    }
  };

  const handleCheck = async () => {
    if (checkingRef.current) return;

    if (!inputFileRef.current || !inputFileRef.current.files?.[0]) {
      toast.error("Vui lòng chọn file để kiểm tra.");
      return;
    }

    if (isKRate) {
      if (!saleOpeningEventId) {
        toast.error("Vui lòng chọn đợt mở bán.");
        return;
      }
      if (!dataKRateId) {
        toast.error("Vui lòng chọn hệ số k.");
        return;
      }
    }

    checkingRef.current = true;
    setIsChecking(true);

    const fileEvent = { target: { files: inputFileRef.current.files } };
    const mapping = columnMappingReverse;

    const run = () =>
      new Promise((resolve, reject) => {
        let settled = false;

        const timer = setTimeout(() => {
          if (settled) return;
          settled = true;
          reject(new Error("Timeout khi đọc file. Vui lòng thử lại."));
        }, 60_000); // 60s

        const doneResolve = (v) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(v);
        };

        const doneReject = (e) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(e);
        };

        try {
          importFile(fileEvent, mapping, typeValue, async (importedData) => {
            try {
              let data = null;

              if (type === "commissionAnalyst") {
                data = await commissionAnalystCall.bulkManyCheck(
                  importedData,
                  saleOpeningEventId,
                  dataKRateId,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "bulkCalculator") {
                data = await commissionAnalystCall.bulkCalculatorCheck(
                  importedData,
                  saleOpeningEventId,
                  dataKRateId,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importTotalCommission") {
                data = await totalCommissionCall.importTotalCommissionCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "deleteTotalCommission") {
                // Dry-run xoá đợt thanh toán — kiểm tra căn, đợt đã import, đã xác nhận CK.
                data = await totalCommissionCall.deletePaymentPeriodByImportCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importBrokerDebtDisbursement") {
                data = await brokerDebtCertificateCall.importCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCcmgByPeriod") {
                // Dry-run: kiểm tra tên, căn, locking, conflict PDV, giới hạn tiền.
                // Không ghi DB — chỉ trả về danh sách lỗi (nếu có).
                data = await brokerDebtCertificateCall.importByPeriodCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCcmgDisbursement") {
                // Dry-run import thanh toán CCMG — kiểm tra nhân viên, tên, certificate,
                // ngày, số tiền. Không ghi DB.
                data = await brokerDebtDisbursementCall.importCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else if (type === "importCcmgDataCheck") {
                // So sánh amountHeld / amountPaid / amountActualRemaining
                // trong Excel với BrokerDebtCertificate DB — không ghi DB.
                data = await brokerDebtCertificateCall.importDataCheck(
                  importedData,
                  inputFileRef.current.files[0].name || "",
                );
              } else {
                return doneReject(new Error("Type này chưa hỗ trợ kiểm tra."));
              }

              if (data?.path && data?.filename) {
                setPathFileError(data.path);
                setNamePathFileError(data.filename);
                setCheckState({
                  hasChecked: true,
                  passed: false,
                  hasErrorFile: true,
                  path: data.path,
                  filename: data.filename,
                });
                return doneResolve({ data, hasErrorFile: true });
              }

              setPathFileError(null);
              setNamePathFileError(null);
              setCheckState({
                hasChecked: true,
                passed: true,
                hasErrorFile: false,
                path: null,
                filename: null,
              });

              return doneResolve({ data, hasErrorFile: false });
            } catch (err) {
              return doneReject(err);
            }
          });
        } catch (err) {
          return doneReject(err);
        }
      });

    try {
      await toast.promise(
        run(),
        {
          loading: "Đang kiểm tra dữ liệu...",
          success: (res) =>
            res?.hasErrorFile
              ? `Kiểm tra xong: có lỗi (${res?.data?.failedCount || 0} dòng).`
              : "Kiểm tra xong: dữ liệu hợp lệ.",
          error: (e) => e?.message || "Kiểm tra thất bại, vui lòng thử lại.",
        },
        {
          id: "popup-import-check",
        },
      );
    } catch (error) {
      console.error("Check error:", error);
    } finally {
      checkingRef.current = false;
      setIsChecking(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="625px">
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"25px 24px 24px 24px"}
          borderBottom={"1px solid var(--color-boder)"}
        >
          <Text
            fontSize={"18px"}
            fontWeight={600}
            lineHeight={"normal"}
            color="var(--color-black)"
          >
            {inputAdd}
          </Text>
          <Image src={iconClose} cursor={"pointer"} onClick={onClose} />
        </Flex>
        <Flex p="24px" justifyContent="space-between" w={"100%"}>
          {!isExport && (
            <HStack spacing="4" w={"100%"}>
              <Input
                type="text"
                placeholder="Chưa có file nào được chọn"
                value={fileName}
                isReadOnly
                cursor="not-allowed"
                bg="gray.100"
                color="gray.800"
                _placeholder={{ color: "gray.500" }}
              />
              <Button
                as="label"
                htmlFor="file-upload"
                bg="blue.500"
                color="white"
                px="4"
                py="2"
                borderRadius="md"
                cursor="pointer"
                _hover={{ bg: "blue.600" }}
                _active={{ bg: "blue.700" }}
              >
                Chọn file
              </Button>
              <Input
                id="file-upload"
                type="file"
                accept=".xlsx, .csv"
                onChange={handleFileChange}
                ref={inputFileRef}
                display="none"
              />
            </HStack>
          )}

          {!isImport && (
            <Button
              ml={3}
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-gradient-excel)"
              _hover={{
                backgroundImage: "var(--color-gradient-excel)",
              }}
              onClick={handleExport}
              minW={"140px"}
            >
              <Image src={iconFile} />
              <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
                {exportTitle ? exportTitle : "Dữ liệu mẫu"}
              </Text>
            </Button>
          )}
        </Flex>
        {type === "importCcmgDisbursement" && (
          <Box p="0 24px" mb={"16px"}>
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={500}
              lineHeight={"15px"}
              mb={"6px"}
              color={"var(--color-black-label)"}
            >
              Chế độ import
            </Text>
            <SearchableSelect
              isShowSearch={false}
              options={[
                { key: 2, value: "Tính lại số tiền đã trả & còn lại" },
                { key: 1, value: "Chỉ thêm lịch sử (không tính lại)" },
              ]}
              initialSelectedOption={{
                key: 2,
                value: "Tính lại số tiền đã trả & còn lại",
              }}
              setValue={setDisbursementMode}
              width="100%"
            />
          </Box>
        )}

        {isTypePrice && (
          <Box p="0 24px">
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={500}
              lineHeight={"15px"}
              mb={"6px"}
              color={"var(--color-black-label)"}
            >
              Dấu phân cách
            </Text>
            <SearchableSelect
              isShowSearch={false}
              options={typeValues}
              initialSelectedOption={{
                key: 0,
                value:
                  "Chọn dấu phân cách đơn vị thập phân của các loại giá hoặc %",
              }}
              setValue={setTypeValue}
              width="100%"
            />
          </Box>
        )}

        {isKRate && (
          <>
            <Box p="0 24px" mt={"24px"}>
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={500}
                lineHeight={"15px"}
                mb={"6px"}
                color={"var(--color-black-label)"}
              >
                Danh sách đợt mở bán
              </Text>
              <SearchableSelect
                isShowSearch={true}
                options={saleOpenEvent}
                initialSelectedOption={{
                  key: 0,
                  value: "Chọn danh sách đợt mở bán",
                }}
                setValue={setSaleOpeningEventId}
                width="100%"
              />
            </Box>

            <Box p="0 24px" mt={"24px"}>
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={500}
                lineHeight={"15px"}
                mb={"6px"}
                color={"var(--color-black-label)"}
              >
                Danh sách hệ số k
              </Text>
              <SearchableSelect
                isShowSearch={true}
                options={dataKRate}
                initialSelectedOption={{
                  key: 0,
                  value: "Chọn hệ số k",
                }}
                setValue={setDataKRateId}
                width="100%"
              />
            </Box>
          </>
        )}

        {!isExport && requiredCheck && (
          <Box p="24px">
            <Button
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-button)"
              _hover={{ backgroundImage: "var(--color-button)" }}
              onClick={handleCheck}
              isLoading={isChecking}
              isDisabled={isChecking}
            >
              <Image src={iconExcel} />
              <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
                {titleCheck}
              </Text>
            </Button>

            {/* trạng thái check */}
            {checkState.hasChecked && checkState.passed && (
              <Text mt="8px" fontSize="14px" color="green.500">
                Đã kiểm tra: Hợp lệ ✅
              </Text>
            )}

            {checkState.hasChecked &&
              checkState.hasErrorFile &&
              checkState.path && (
                <Flex
                  mt="10px"
                  p="10px"
                  border="1px solid"
                  borderColor="red.200"
                  borderRadius="8px"
                  align="center"
                  justify="space-between"
                  gap={4}
                >
                  <Box maxW={"80%"}>
                    <Text fontSize="14px" color="red.500">
                      Có file lỗi: {checkState.filename}
                    </Text>
                  </Box>

                  <Button
                    size="sm"
                    leftIcon={<DownloadIcon />}
                    onClick={() =>
                      window.open(`${baseURL}${checkState.path}`, "_blank")
                    }
                  >
                    Tải file lỗi
                  </Button>
                </Flex>
              )}
          </Box>
        )}

        {!isExport && !checkOnly && (!requiredCheck || checkState.passed) && (
          <Box p="24px">
            <Button
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-button)"
              _hover={{
                backgroundImage: "var(--color-button)",
              }}
              onClick={handleImport}
            >
              <Image src={iconExcel} />
              <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
                {titleAdd}
              </Text>
            </Button>
          </Box>
        )}

        {isExport && onImport && titleImport && (
          <Box p="24px">
            <Button
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-button)"
              _hover={{
                backgroundImage: "var(--color-button)",
              }}
              onClick={onImport}
            >
              <Text fontSize="15px" fontWeight="600" color="var(--color-main)">
                {titleImport || "Import giá tính phí dịch vụ"}
              </Text>
            </Button>
          </Box>
        )}
      </ModalContent>
      <FormFileImportError
        isOpen={isOpenError}
        onClose={handleCloseError}
        pathError={pathFileError}
        filename={namePathFileError}
      />
    </Modal>
  );
};

const FormFileImportError = ({ isOpen, onClose, pathError, filename }) => {
  const onDownLoad = (file) => {
    console.log(file);
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = file;
    link.click();
    if (document.body.contains(link)) {
      document.body.removeChild(link);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="625px" minH={"350px"}>
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"25px 24px 24px 24px"}
          borderBottom={"1px solid var(--color-boder)"}
        >
          <Text
            fontSize={"18px"}
            fontWeight={600}
            lineHeight={"normal"}
            color="var(--color-black)"
          >
            File lỗi
          </Text>
          <Image src={iconClose} cursor={"pointer"} onClick={onClose} />
        </Flex>
        <Flex
          mt={"24px"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Flex
            gap={"4px"}
            alignItems={"center"}
            color={"var(--color-secondary)"}
          >
            <Image src={iconFile} />
            {filename ? filename : "File lỗi"}
          </Flex>
          <Button
            bg={"none"}
            leftIcon={<DownloadIcon color={"var(--color-secondary)"} />}
            colorScheme="teal"
            onClick={() =>
              onDownLoad(pathError ? `${baseURL}${pathError}` : "")
            }
            _hover={{
              filter: "brightness(90%)",
            }}
            p={"0px"}
            w={"max-content"}
            position={"relative"}
          ></Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default PopupImport;
